export class Diagnosis {

  diagnosisID: number;
  diagnosisName: string;
  diagnosisCode: string;
  isCommon: boolean;
  createdAt: Date;
  createdBy: number;
  modifiedAt: Date;
  modifiedBy: number;

}
